import React from 'react'

/**
 * Card component with consistent styling
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Card content
 * @param {string} props.className - Additional CSS classes
 * @param {boolean} props.isSelected - Whether card is selected
 * @param {boolean} props.isExpanded - Whether card is expanded
 * @param {function} props.onClick - Click handler function
 */
const Card = ({
  children,
  className = '',
  isSelected = false,
  isExpanded = false,
  onClick,
  ...rest
}) => {
  // Base styles
  const baseStyles =
    'card bg-white rounded-lg shadow-lg border border-gray-200 transition-all duration-200'

  // Selected styles - simple green border for selected items
  const selectedStyles = isSelected ? 'border-green-500' : ''

  return (
    <div
      className={`${baseStyles} ${selectedStyles} ${className}`}
      onClick={onClick}
      data-expanded={isExpanded}
      {...rest}
    >
      {children}
    </div>
  )
}

/**
 * Card.Header component
 */
Card.Header = ({ children, className = '', ...rest }) => (
  <div className={`p-4 border-b border-gray-200 ${className}`} {...rest}>
    {children}
  </div>
)

/**
 * Card.Body component
 */
Card.Body = ({ children, className = '', ...rest }) => (
  <div className={`p-4 flex-grow ${className}`} {...rest}>
    {children}
  </div>
)

/**
 * Card.Footer component
 */
Card.Footer = ({ children, className = '', ...rest }) => (
  <div
    className={`p-4 border-t border-gray-200 bg-gray-50 mt-auto ${className}`}
    {...rest}
  >
    {children}
  </div>
)

export default Card
